import { Filter } from 'bad-words';

const filter = new Filter();

export const containsProfanity = (text) => {
    if (!text || typeof text !== 'string') return false;
    return filter.isProfane(text);
};

export const checkFieldsForProfanity = (fields) => {
    for (const [label, value] of Object.entries(fields)) {
        if (containsProfanity(value)) {
            return `"${label}" contains inappropriate language. Please revise your input.`;
        }
    }
    return null;
};
